export enum Page {
  PreLogin,
  Login,
}
